import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "../initialState";
import api from "../../api";

export const GetAllCashflow = createAsyncThunk(
  "cashflow/GetAllCashflow",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}cashflow/all${data.query}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleCashflow = createAsyncThunk(
  "cashflow/GetSingleCashflow",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}cashflow/get_by_id/${data.id}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const cashflowSlice = createSlice({
  name: "cashflow",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all cashflow
    builder.addCase(GetAllCashflow.pending, loadingHandler);
    builder.addCase(GetAllCashflow.fulfilled, fulfilledHandler);
    builder.addCase(GetAllCashflow.rejected, rejectedHandler);
    // fetch cashflow by id
    builder.addCase(GetSingleCashflow.pending, loadingHandler);
    builder.addCase(GetSingleCashflow.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleCashflow.rejected, rejectedHandler);
  },
});

export const { reset } = cashflowSlice.actions;
export default cashflowSlice.reducer;
